import type { ReactNode } from 'react';

import { AgentCreditAllowanceInChatBanner } from './AgentCreditAllowanceBanner';
import { placeAgentCreditAllowanceBanner } from './resolve-agent-credit-allowance-banner';
import { useAgentCreditAllowanceBannerState } from './useAgentCreditAllowanceBannerState';

/** Landing default keeps 100 on the dock. Bound chats pass `{ inThread: true }`. */
export function useAgentCreditAllowanceInChatChrome(
  enabled: boolean,
  options?: { inThread?: boolean }
) {
  const { surface, hideFollowUpQuestions, sendDisabled } =
    useAgentCreditAllowanceBannerState();
  const placement = enabled
    ? placeAgentCreditAllowanceBanner({
        surface,
        inThread: options?.inThread ?? false,
      })
    : null;
  const banner =
    placement != null ? (
      <AgentCreditAllowanceInChatBanner placement={placement} />
    ) : undefined;

  return {
    composerDockLeading: placement === 'composer' ? banner : undefined,
    transcriptTrailing: placement === 'transcript' ? banner : undefined,
    hideFollowUpQuestions: enabled && hideFollowUpQuestions,
    sendDisabled: enabled && sendDisabled,
  } satisfies {
    composerDockLeading: ReactNode;
    transcriptTrailing: ReactNode;
    hideFollowUpQuestions: boolean;
    sendDisabled: boolean;
  };
}
